import { CellTypes, DataGrid, Drawer } from '@fashionnovateam/nova-ui-toolkit';
import { RolesAndPermissionProps } from '../RolesAndPermissions/RolesAndPermission';

type RolesAndPermissionDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

type PermissionRow = {
  id: number;
  page: CellTypes.DataGridCellCustomParams;
};

function formatAccessData(inputData: RolesAndPermissionProps['data']) {
  const formattedData = [];
  let id = 0;
  for (const page in inputData) {
    if (Object.prototype.hasOwnProperty.call(inputData, page)) {
      const roles = inputData[page];
      formattedData.push({
        id,
        page: <span className="text-xsm font-semibold">{page}</span>,
        ...Object.entries(roles).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]: {
              contrast: 'low' as const,
              children: value ? 'Yes' : 'No',
              color: value ? ('green' as const) : ('red' as const),
            },
          }),
          {},
        ),
      });
      id += 1;
    }
  }
  return formattedData satisfies PermissionRow[];
}

type RolesData = {
  [key: string]: {
    Admin: boolean;
    Staff: boolean;
    Operations: boolean;
  };
};

const data: RolesData = {
  Dashboard: {
    Admin: true,
    Staff: false,
    Operations: false,
  },
  'Item Requests': {
    Admin: true,
    Staff: true,
    Operations: false,
  },
  'Purchase Orders': {
    Admin: true,
    Staff: true,
    Operations: true,
  },
  Deliveries: {
    Admin: true,
    Staff: true,
    Operations: false,
  },
  Catalog: {
    Admin: true,
    Staff: true,
    Operations: false,
  },
  Invoices: {
    Admin: true,
    Staff: false,
    Operations: false,
  },
  Credits: {
    Admin: true,
    Staff: false,
    Operations: false,
  },
  Payments: {
    Admin: true,
    Staff: false,
    Operations: false,
  },
  Profile: {
    Admin: true,
    Staff: false,
    Operations: false,
  },
  Factories: {
    Admin: true,
    Staff: false,
    Operations: false,
  },
};
export function RolesAndPermissionDrawer({
  isOpen,
  onClose,
}: RolesAndPermissionDrawerProps) {
  return (
    <Drawer width="635px" isOpen={isOpen} onClose={onClose}>
      <Drawer.Header>
        <Drawer.Title>Member Roles</Drawer.Title>
        <Drawer.Description className="mt-2">
          Admins have full access to your dashboard. Staff have limited
          visibility to financial data and cannot manage your users or your
          company profile.
        </Drawer.Description>
      </Drawer.Header>
      <Drawer.Content className="py-4">
        <DataGrid
          stateName="roles_and_permissions"
          hideFilterButton
          hideGroupButton
          pageSizeOptions={[15]}
          columns={[
            {
              field: 'page',
              headerName: 'Page',
              render: 'custom',
              flex: 1,
              display: 'flex',
              minWidth: 150,
              disableColumnMenu: true,
              sortable: false,
            },
            ...Object.keys(data[Object.keys(data)[0]]).map((role) => ({
              field: role,
              headerName: role,
              render: 'badge' as const,
              flex: 1,
              minWidth: 110,
              disableColumnMenu: true,
              sortable: false,
            })),
          ]}
          rows={formatAccessData(data)}
          hideFooterPagination
        />
      </Drawer.Content>
    </Drawer>
  );
}
